import useGetSellerConfiguration from '../../../hooks/useGetSellerConfiguration';
import { useIsBTobEnabled } from '../../../hooks/useIsBTobEnabled';
import { ROUTES } from '../../../routes/Routes';
import { PROFESSIONAL_HOME_CONFIG } from '../../ProfessionalRoutes.config';
import { buildProfessionalRoute } from '../../ProfessionalRoutes.helpers';

interface UseGetSellerUrlArgs {
  sellerId: string;
}

export const useGetSellerUrl = ({ sellerId }: UseGetSellerUrlArgs) => {
  const { sellerConfiguration } = useGetSellerConfiguration({ sellerId });

  const isBTobEnabled = useIsBTobEnabled();

  const defaultRoute = isBTobEnabled
    ? buildProfessionalRoute({
        route: PROFESSIONAL_HOME_CONFIG.PROFESSIONAL_HOME_PAGE,
      })
    : ROUTES.HOME;

  const sellerUrl = sellerConfiguration?.defaultOwnerOrderUrl
    ? { href: sellerConfiguration?.defaultOwnerOrderUrl, isExternal: true }
    : { href: defaultRoute, isExternal: false };

  return {
    sellerUrl,
  };
};
